import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { IconComponent } from '../../../../ui/icon/icon/icon.component';

@Component({
  selector: 'app-playback-button',
  templateUrl: './playback-button.component.html',
  styleUrls: ['./playback-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class PlaybackButtonComponent {
  readonly icon = input.required<string>();
  readonly clickEvent = output<void>();

  onClick(): void {
    this.clickEvent.emit();
  }
}
